import { Component, OnInit } from '@angular/core';

import { AppData } from '../services/appdata.service';
import { Global } from '../services/global.service';

import { Config } from '../models/env-vars.model';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

	arc_pro_label: string = Config.arc_pro_label;

	constructor(
		public global: Global,
		public appData: AppData
	) 
	{}

	ngOnInit(): void
	{
		if(this.appData.get('is_admin'))
		{
			this.global.goToApp('projects');
		}
	}
}
